const EN_TO_RU = {
  'q':'й','w':'ц','e':'у','r':'к','t':'е','y':'н','u':'г','i':'ш','o':'щ','p':'з',
  '[':'х',']':'ъ','a':'ф','s':'ы','d':'в','f':'а','g':'п','h':'р','j':'о','k':'л',
  'l':'д',';':'ж',"'":'э','z':'я','x':'ч','c':'с','v':'м','b':'и','n':'т','m':'ь',
  ',':'б','.':'ю','`':'ё',
  'Q':'Й','W':'Ц','E':'У','R':'К','T':'Е','Y':'Н','U':'Г','I':'Ш','O':'Щ','P':'З',
  '{':'Х','}':'Ъ','A':'Ф','S':'Ы','D':'В','F':'А','G':'П','H':'Р','J':'О','K':'Л',
  'L':'Д',':':'Ж','"':'Э','Z':'Я','X':'Ч','C':'С','V':'М','B':'И','N':'Т','M':'Ь',
  '<':'Б','>':'Ю','~':'Ё',
};

const RU_TO_EN = Object.fromEntries(Object.entries(EN_TO_RU).map(([k, v]) => [v, k]));

function convertText(text, map) {
  return [...text].map(ch => (ch === ' ' ? ' ' : (map[ch] ?? ch))).join('');
}

export function detectAndConvert(text) {
  if (!text || text.trim().length < 2) return null;

  const nonSpace = [...text].filter(c => c !== ' ');
  if (nonSpace.length === 0) return null;

  // Все латинские → пробуем en→ru
  if (nonSpace.every(c => c in EN_TO_RU)) {
    return convertText(text, EN_TO_RU);
  }

  // Все кириллические → пробуем ru→en
  if (nonSpace.every(c => c in RU_TO_EN)) {
    return convertText(text, RU_TO_EN);
  }

  return null;
}
